import React from 'react';

import usePage from '@dashboard/hooks/usePage';

import PageEditView from '../../components/PageEditView';
import PageFieldsForm from '../../components/PageFieldsForm';
import FormTitleForm from '../PageForm/components/FormTitleForm';
import AttendeeQuestions from '../PageGroupRegistration/AttendeeQuestions';
import { editorSection } from '../../pageEditTabs';

// On events, Form fields holds two pages: what the customer is asked, and what each attendee is.
export const getFieldsSections = ({ page }) =>
  [
    {
      ...editorSection('fields', '/form-fields', { page }),
      component:
        page?.type === 'form' ? (
          <>
            <div className="mb-6">
              <FormTitleForm />
            </div>
            <PageFieldsForm />
          </>
        ) : (
          <PageFieldsForm />
        ),
      description: 'Collect customer information.',
      helpUrl: '/docs/articles/how-to-add-custom-fields',
    },
    {
      ...editorSection('fields', '/attendee-questions', { page }),
      description: 'Asked for each attendee on a booking.',
      component: <AttendeeQuestions />,
    },
  ].filter(section => section.isVisible({ page }));

const PageFields = () => {
  const { page } = usePage();
  return <PageEditView tabs={getFieldsSections({ page })} />;
};

export default PageFields;
